module.exports = __webpack_public_path__ + "static/img/naniungo-slide-5.fe174a16.jpg";